// const $ = require('jquery');
// const debug = false;

// function ifDebugAlert(message: any) {
// 	if (debug) {
// 		alert(message); // eslint-disable-line no-alert
// 	}
// }

/**
* Intercepts keydown events so that right and left arrow keys can be used to navigate
* between journal entries. It assumes the page calling this function Hasbro
* anchors with IDs Next and Prev
* @param e  KeyboardEvent
*/
// function rbkeydown(e: KeyboardEvent) {
// 	const code = (e.key);// ? e.keyCode : e.charCode;
// 	ifDebugAlert('helo');

// 	if (code === "ArrowRight") {
// 		ifDebugAlert('your pressed next');
// 		const a = $(`.next`);
// 		if (a.length > 0) {
// 			const aElement = a.get(0);
// 			const h = aElement.href;
// 			const href = $(a.get(0)).attr('href');
// 			window.location.replace(href);
// 		} else {
// 			ifDebugAlert('null next');
// 		}
// 	} else if (code === "ArrowLeft") {
// 		ifDebugAlert('your pressed previous');
// 		const a = $(`.prev`);
// 		if (a.length > 0) {
// 			const href = $(a.get(0)).attr('href');
// 			window.location.replace(href);
// 		} else {
// 			ifDebugAlert('null prev');
// 		}
// 	} else {
// 		ifDebugAlert(`invalid key code: ${parseInt(code, 10)}`);
// 	}
// }
/* Have to make the next/prev navigation at the window level - this is higher in the
* event bubbling hierachy than the level at which lightbox sets the handler - it uses document.
* I do this so that lighbox gets the event first and stops it bubbing up.
*/

export function enable() {
	const content_el = document//.getElementById("contents") as HTMLDivElement
	const lb = document.getElementById("jquery-lightbox")
	if(lb) {
		return
	}
	document.addEventListener("keydown", (event: KeyboardEvent) => {
		const lightbox = document.getElementById("jquery-lightbox");
		if(lightbox) {
			return
		}
		if((event.key === "ArrowRight") && (!event.repeat)) {
			const a_el = document.querySelector("a.next") as HTMLAnchorElement
			const href = a_el.getAttribute('href')
			window.location.replace(href);			
		} 
		if((event.key === "ArrowLeft") && (!event.repeat)) {
			const a_el = document.querySelector("a.prev") as HTMLAnchorElement
			const href = a_el.getAttribute('href')
			window.location.replace(href);			
		}
	})
	// return
	// window.onkeydown = (event) => {
	// 	rbkeydown(event);
	// };
};
